import {
  IconButton,
  Stack,
  TabPanel,
  TabPanelProps,
  Td,
  Th,
  Tr,
} from '@chakra-ui/react';
import { useFetchUsersPageQuery } from 'api';
import { useAuth, usePagination } from 'core';
import { AppButton, CurrencyLabel } from 'features/components';
import { AppTable } from 'features/table';
import { useState } from 'react';
import { CreateUserDrawer } from './CreateUserDrawer';
import { EditUserDrawer } from './EditUserDrawer';
import { User } from 'api/bindings/User';
import { UserResponse } from 'api/bindings/UserResponse';
import { FiPenTool, FiPlus } from 'react-icons/fi';

export interface ClientUsersTabPanelProps extends TabPanelProps {}

export const ClientUsersTabPanel = (props: ClientUsersTabPanelProps) => {
  const { ...others } = props;
  const auth = useAuth();
  const [page, setPagination] = usePagination();
  const { data: users, isLoading } = useFetchUsersPageQuery({
    ...page,
    clientId: auth?.user?.clientId ?? '0',
  });
  const [editingUser, setEditingUser] = useState<UserResponse>();
  const [showCreateUser, setShowCreateUser] = useState<boolean>();

  let body = (
    <>
      <Tr>
        <Td colSpan={9}>Loading...</Td>
      </Tr>
    </>
  );

  if (!isLoading) {
    body = (
      <>
        {users?.items.map((user, i) => (
          <Tr key={i}>
            <Td>
              <IconButton
                aria-label="Edit User"
                icon={<FiPenTool />}
                onClick={() => setEditingUser(user)}
              />
            </Td>
            <Td>{user.firstName}</Td>
            <Td>{user.lastName}</Td>
            <Td>{user.preferredName}</Td>
            <Td>{user.email}</Td>
            <Td>
              <CurrencyLabel value={user.afeApprovalAuthority} />
            </Td>
            <Td>
              <CurrencyLabel value={user.purchaseOrderApprovalAuthority} />
            </Td>
            <Td>
              <CurrencyLabel value={user.workOrderApprovalAuthority} />
            </Td>
            <Td>
              <CurrencyLabel value={user.invoiceApprovalAuthority} />
            </Td>
            {/* <Td>
              <AppButton onClick={() => setEditingUser(user)}>Edit</AppButton>
            </Td> */}
          </Tr>
        ))}
      </>
    );
  }

  return (
    <TabPanel {...others}>
      {showCreateUser && (
        <CreateUserDrawer
          isOpen={true}
          onClose={() => setShowCreateUser(undefined)}
        />
      )}
      {editingUser && (
        <EditUserDrawer
          isOpen={true}
          user={editingUser}
          onClose={() => setEditingUser(undefined)}
        />
      )}
      <Stack>
        {/* <AppButton
          colorScheme="blue"
          onClick={() => setShowCreateUser(true)}
          mb={4}
        >
          Create User
        </AppButton> */}
        <AppTable
          title="Search Users"
          body={body}
          pagination={{
            ...page,
            itemCount: Number(users?.itemCount ?? 0),
            pageCount: Number(users?.pageCount ?? 0),
          }}
          buttonGroup={(props) => (
            <AppButton
              variant="solid"
              leftIcon={<FiPlus />}
              onClick={() => setShowCreateUser(true)}
            >
              Create User
            </AppButton>
          )}
          onPaginationChange={setPagination}
          header={
            <>
              <Tr>
                <Th></Th>
                <Th>First Name</Th>
                <Th>Last Name</Th>
                <Th>Preferred Name</Th>
                <Th>E-mail</Th>
                <Th>AFE Authority</Th>
                <Th>PO Authority</Th>
                <Th>WO Authority</Th>
                <Th>Invoice Authority</Th>
              </Tr>
            </>
          }
        />
      </Stack>
    </TabPanel>
  );
};
